const fontInfo = [
    {
        "category": "handwriting",
        "name": "Indie Flower",
        "sane": "indie_flower",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Dancing Script",
        "sane": "dancing_script",
        "variants": [
            "0,400",
            "0,500",
            "0,600",
            "0,700"
        ]
    },
    {
        "category": "handwriting",
        "name": "Pacifico",
        "sane": "pacifico",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Shadows Into Light",
        "sane": "shadows_into_light",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Satisfy",
        "sane": "satisfy",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Gloria Hallelujah",
        "sane": "gloria_hallelujah",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Architects Daughter",
        "sane": "architects_daughter",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Kaushan Script",
        "sane": "kaushan_script",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Great Vibes",
        "sane": "great_vibes",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Cookie",
        "sane": "cookie",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Sacramento",
        "sane": "sacramento",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Tangerine",
        "sane": "tangerine",
        "variants": [
            "0,400",
            "0,700"
        ]
    },
    {
        "category": "handwriting",
        "name": "Marck Script",
        "sane": "marck_script",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Covered By Your Grace",
        "sane": "covered_by_your_grace",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Parisienne",
        "sane": "parisienne",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Homemade Apple",
        "sane": "homemade_apple",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Bad Script",
        "sane": "bad_script",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Gochi Hand",
        "sane": "gochi_hand",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Crafty Girls",
        "sane": "crafty_girls",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Allura",
        "sane": "allura",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Pinyon Script",
        "sane": "pinyon_script",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Calligraffitti",
        "sane": "calligraffitti",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Just Another Hand",
        "sane": "just_another_hand",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Itim",
        "sane": "itim",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "Niconne",
        "sane": "niconne",
        "variants": [
            "0,400"
        ]
    },
    {
        "category": "handwriting",
        "name": "The Girl Next Door",
        "sane": "the_girl_next_door",
        "variants": [
            "0,400"
        ]
    },
]

export default fontInfo
